import { locationSlug } from '@/helpers/urlTs';
import { SearchManagerOutput } from '@/hooks/search/useSearch';
import { DEFAULT_MY_LOCATION_KEYWORD } from '@/hooks/search/useSearch.constants';
import { _s } from '@/locale';

export function getSearchPlaceholderText(search: Pick<SearchManagerOutput, 'q' | 'location'>): {
  keyword: string;
  location: string;
} {
  if (search.q && search.location) {
    return {
      keyword: search.q,
      location: locationSlug(search.location) !== DEFAULT_MY_LOCATION_KEYWORD ? search.location : _s('fakeSearchNear'),
    };
  }
  if (search.q) {
    return {
      keyword: search.q,
      location: _s('allSweden'),
    };
  }

  if (search.location) {
    return {
      keyword: _s('Everything'),
      location: locationSlug(search.location) !== DEFAULT_MY_LOCATION_KEYWORD ? search.location : _s('fakeSearchNear'),
    };
  }

  return {
    keyword: _s('Everything'),
    location: _s('AllSweden'),
  };
}
